import React from "react";
import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "@/utils/dsBridge";
import useInApp from "@/hooks/useIsApp";
import { useRouter } from "next/router";
import clsx from "clsx";
import { BackUseIcon, CloseUseIcon, CustomerUseIcon } from "@/containers/layout/NavigationIcons";

interface SurveyHeaderProps {
	hiddenBackBtn?: boolean;
	hiddenCloseBtn?: boolean;
	onBackClick?: () => void;
	onCloseClick?: () => void;
	onCustomServiceClick?: () => void;
	space?: boolean;
}

export default function SurveyHeader({
	hiddenBackBtn = false,
	hiddenCloseBtn = false,
	space = false,
	onBackClick,
	onCloseClick,
	onCustomServiceClick,
}: SurveyHeaderProps) {
	const router = useRouter();
	const isInApp = useInApp();

	const openCustomService = () => {
		if (onCustomServiceClick) return onCustomServiceClick();
		if (isInApp) {
			bridge.call(BridgeCallHandlers.ON_CUSTOMER_SERVICE_BUTTON_CLICK);
			return;
		}
		window.open(`${window.location.origin}/${router.locale}/contact-us`, "_blank");
	};

	const closePage = () => {
		if (onCloseClick) return onCloseClick();
		bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
	};

	return (
		<div className={clsx("flex h-12 items-center justify-between", space ? "" : "px-4.5")}>
			<div className="flex max-w-[25%] flex-grow-0 basis-1/4 items-center">
				{hiddenBackBtn || !isInApp ? null : <BackUseIcon space="trailing" onClick={onBackClick} />}

				{isInApp && !hiddenCloseBtn && <CloseUseIcon onClick={closePage} space="trailing" />}
			</div>

			<div className="max-w-[50%] flex-grow-0 basis-1/2"></div>

			<div className="flex max-w-[25%] flex-grow-0 basis-1/4 justify-end">
				<CustomerUseIcon onClick={openCustomService} />
			</div>
		</div>
	);
}
